<template>
    <div v-bind:class="rowClass">
        <div class="label" v-if="label">{{ label }}</div>
        <div class="value" v-html="htmlValue"></div>
    </div>
</template>

<script>
export default {
    name: "VSLHtmlRowRenderer",
    props: {
        label: String,
        value: null
    },

    computed: {
        rowClass() {
            return this.label ? "vsl-row vsl-html-row vsl-html-row-grid" : "vsl-row vsl-html-row";
        },

        htmlValue() {
            return this.value ? this.value.toString() : ""
        }
    }
}
</script>

<style>
.vsl-html-row {
    max-width: 100%;
    width: 100%;
}

.vsl-html-row-grid {
    display: grid;
    grid-template-columns: 30% 70%;
    justify-content: left;
    column-gap: 8px;
}

.label {
    display: inline-block;
    max-width: 300px;
    text-align: left;
    vertical-align: top;
}

.value {
    display: inline-block;
    max-width: 100%;
    text-align: left;
    vertical-align: top;
}

.value a {
    white-space: pre-wrap; /* CSS3 */    
    white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
    white-space: -pre-wrap; /* Opera 4-6 */    
    white-space: -o-pre-wrap; /* Opera 7 */    
    word-wrap: break-word;
}

.value p a {
    word-wrap: break-word;
}
</style>